export enum LineStatus {

  CANCELED = 'CANCELED', //Ligne FO
  UNKNOWN = 'UNKNOWN', // Inconnu
  TO_SAVE = 'TO_SAVE', // Panier
  IN_PROGRESS = 'IN_PROGRESS',
  SENT = 'SENT' // Expedier logilab

}
